<template>
  <div></div>
</template>
<script>
import {
  GetInquiry
} from "@/utils/api.js";
import {Toast} from "vant"
export default {
  methods: {
    continued(id) {
      GetInquiry({
        AppKey: this.$store.state.AppKey,
        Token,
        InquiryId: id
      })
        .then(res => {
          if (res == "Again") {
            this.continued(id);
            return;
          } else if (res.errcode == 0) {
            Toast.loading({
              message: "跳转中",
              duration: 0
            });
            let data = res.InquiryInfo;
            data.PicList.map(item => {
              item.content = item.Url;
            });
            let person = [
              { text: "", tip: "name" },
              { text: "", tip: "carId" },
              { text: "", tip: "bornDate" },
              { text: "", tip: "sex" },
              { text: "", tip: "phone" },
              {
                text: "",
                tip: "about",
                testList: [
                  { name: "", title: "过往病史" },
                  { name: "", title: "过敏史" },
                  { name: "", title: "家族病史" },
                  { name: "", title: "妊娠哺乳" },
                  { name: "", title: "肝功能" },
                  { name: "", title: "肾功能" }
                ]
              }
            ];
            let hsitoryDisList = [
              {
                type: 0,
                name: "过往病史",
                radio: "0",
                text1: "有",
                text2: "无",
                medList: [
                  { name: "先天性心脏病", sel: false, sys: true },
                  { name: "阴道炎", sel: false, sys: true },
                  { name: "月经失调", sel: false, sys: true },
                  { name: "肿瘤", sel: false, sys: true },
                  { name: "动脉硬化", sel: false, sys: true },
                  { name: "脑血管病", sel: false, sys: true },
                  { name: "糖尿病", sel: false, sys: true }
                ],
                showAdd: true
              },
              {
                type: 1,
                name: "过敏史",
                radio: "0",
                text1: "有",
                text2: "无",
                medList: [
                  { name: "青霉素", sel: false, sys: true },
                  { name: "动物皮屑", sel: false, sys: true },
                  { name: "尘螨", sel: false, sys: true },
                  { name: "灰尘", sel: false, sys: true },
                  { name: "花粉", sel: false, sys: true },
                  { name: "鸡蛋", sel: false, sys: true },
                  { name: "牛奶", sel: false, sys: true },
                  { name: "鱼,虾,海产品", sel: false, sys: true },
                  { name: "阿司匹林", sel: false, sys: true }
                ],
                showAdd: true
              },
              {
                type: 2,
                name: "家族病史",
                radio: "0",
                text1: "有",
                text2: "无",
                medList: [
                  { name: "先天性心脏病", sel: false, sys: true },
                  { name: "阴道炎", sel: false, sys: true },
                  { name: "月经失调", sel: false, sys: true },
                  { name: "肿瘤", sel: false, sys: true },
                  { name: "动脉硬化", sel: false, sys: true },
                  { name: "脑血管病", sel: false, sys: true },
                  { name: "糖尿病", sel: false, sys: true }
                ],
                showAdd: true
              },
              {
                type: 3,
                name: "妊娠哺乳",
                radio: "0",
                text1: "有",
                text2: "无",
                medList: [
                  { name: "备孕中", sel: false, sys: true },
                  { name: "怀孕中", sel: false, sys: true },
                  { name: "正在哺乳", sel: false, sys: true }
                ],
                showAdd: false
              },
              {
                type: 4,
                name: "肝功能",
                radio: "0",
                text1: "异常",
                text2: "正常",
                medList: [],
                showAdd: false
              },

              {
                type: 5,
                name: "肾功能",
                radio: "0",
                text1: "异常",
                text2: "正常",
                medList: [],
                showAdd: false
              }
            ];
            person[0].text = data.Name;
            person[1].text = data.IDCard;
            person[2].text = data.Birthdate;
            person[3].text = data.Sex == 1 ? "男" : "女";
            person[4].text = data.PhoneNo;
            person[5].text = "";

            hsitoryDisList[0].radio = data.PMHType;
            hsitoryDisList[1].radio = data.AMHType;
            hsitoryDisList[2].radio = data.FMHType;
            hsitoryDisList[3].radio = data.NurseType;
            hsitoryDisList[4].radio = data.LiverType;
            hsitoryDisList[5].radio = data.RenalType;
            // hsitoryDisList.map(item=>{
            //   if(item.radio==1){
            //     person[5].text+=item.name+","
            //   }
            // })
            // person[5].text=person[5].text.substring(0,person[5].text.length-1)

            data.DiseaseList.map(item => {
              item.sel = true;
            });
            data.DrugsList.map(item => {
              item.num = item.Count;
            });

            person[5].testList[0].name = data.PMH || "";
            person[5].testList[1].name = data.AMH || "";
            person[5].testList[2].name = data.FMH || "";
            person[5].testList[3].name = data.NurseDesc || "";
            person[5].testList[4].name = data.LiverDesc || "";
            person[5].testList[5].name = data.RenalDesc || "";
            hsitoryDisList.map((item, index) => {
              let temArr = [];
              let arr = person[5].testList[index].name.split("、");
              item.medList.map((it, inx) => {
                arr.map((items, indexs) => {
                  if (items == it.name) {
                    it.sel = true;
                  }
                });
              });
              // 判断返回的值是否存在不是系统默认的值
              arr.map((items, indexs) => {
                let count = item.medList.every((it, inx) => {
                  return items != it.name;
                });
                if (count) {
                  temArr.push({
                    sys: false,
                    sel: true,
                    name: items
                  });
                  temArr.map(items3 => {
                    if (items3.name) {
                      item.medList.push(items3);
                    }
                  });
                }
              });
            });
            let onlyDrugsList = data.DiseaseList.filter(item => {
              item.isMain == 1;
            });
            if (onlyDrugsList[0]) {
              if (onlyDrugsList[0].DiseaseList.length > 0) {
                onlyDrugsList[0].DiseaseList.map(item => {
                  data.DiseaseList.map(items => {
                    if (item.Name == items.Name) {
                      items.sys = true;
                    }
                  });
                });
              }
            }
            let str = "";
            hsitoryDisList.map((item, index) => {
              if (item.radio == 1) {
                if (index == 4 || index == 5) {
                  str += item.name + "异常、";
                } else {
                  str += "有" + item.name + "、";
                }
              }
            });
            if (str == "") {
              person[5].text = "无";
            } else {
              person[5].text = str.substring(0, str.length - 1);
            }

            sessionStorage.setItem(
              "fillData",
              JSON.stringify({
                currentDate: data.Birthdate,
                diseaseList: data.DiseaseList,
                imgList: data.PicList,
                description: data.SymptomDesc,
                addDrugsList: data.DrugsList,
                hsitoryDisList,
                person,
                weight: data.Weight
              })
            );
            sessionStorage.setItem("firstHis", true);
            console.log(213);
            Toast.clear();
            this.clear = false;
            console.log(JSON.parse(sessionStorage.getItem("fillData")));
            sessionStorage.removeItem('his_people')
            this.$router.replace({
              path: "/fill",
              query: { type: "keep", ModeType: data.ModeType }
            });
          } else {
            Toast("请求错误，请稍后再试");
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 点击拒绝原因里面的内容
    clickTip(type) {
      console.log(type);
      if (type == 1) {
        this.refuse = false;
      } else {
        this.continued(this.InquiryId);
      }
    }
  },
  mounted() {

    if (this.$route.query.id && this.$route.query.type == 1) {
        this.continued(this.$route.query.id)
    }
  }
};
</script>